import {
  faTwitter as freeFabFaTwitter,
  faFacebookSquare as freeFabFaFacebookSquare,
  faInstagram as freeFabFaInstagram,
  faYoutube as freeFabFaYoutube
} from '@fortawesome/free-brands-svg-icons'

import {
  faEnvelope as proFasFaEnvelope,
  faTimes as proFasFaTimes,
  faAngleRight as proFasFaAngleRight,
  faAngleLeft as proFasFaAngleLeft,
  faPlay as proFasFaPlay,
  faTrashAlt as proFasFaTrashAlt,
  faExclamation as proFasFaExclamation,
  faCheck as proFasFaCheck,
  faSort as proFasFaSort,
  faStar as proFasFaStar,
  faStarHalf as proFasFaStarHalf,
  faStarHalfAlt as proFasFaStarHalfAlt,
  faImage as proFasFaImage
} from '@fortawesome/pro-solid-svg-icons'

import {
  faEnvelope as proFarFaEnvelope,
  faAngleRight as proFarFaAngleRight,
  faAngleLeft as proFarFaAngleLeft,
  faPlusCircle as proFarFaPlusCircle,
  faMinusCircle as proFarFaMinusCircle,
  faChevronDown as proFarFaChevronDown,
  faWifi as proFarFaWifi,
  faList as proFarFaList,
  faMap as proFarFaMap,
  faTimes as proFarFaTimes,
  faStream as proFarFaStream,
  faTruck as proFarFaTruck,
  faTshirt as proFarFaTshirt,
  faStar as proFarFaStar,
  faStarHalf as proFarFaStarHalf,
  faStarHalfAlt as proFarFaStarHalfAlt,
  faTrashAlt as proFarFaTrashAlt,
  faMinus as proFarFaMinus,
  faPlus as proFarFaPlus,
  faCheck as proFarFaCheck,
  faChevronRight as proFarFaChevronRight
} from '@fortawesome/pro-regular-svg-icons'

import {
  faEnvelope as proFalFaEnvelope,
  faShoppingBag as proFalFaShoppingBag,
  faAngleRight as proFalFaAngleRight,
  faAngleLeft as proFalFaAngleLeft,
  faPlusCircle as proFalFaPlusCircle,
  faMinusCircle as proFalFaMinusCircle,
  faArrowRight as proFalFaArrowRight,
  faSpinner as proFalFaSpinner,
  faCheck as proFalFaCheck,
  faTimes as proFalFaTimes,
  faSpinnerThird as proFalFaSpinnerThird,
  faChevronDown as proFalFaChevronDown,
  faChevronLeft as proFalFaChevronLeft,
  faChevronUp as proFalFaChevronUp,
  faChevronRight as proFalFaChevronRight,
  faSlidersV as proFalFaSlidersV,
  faUser as proFalFaUser,
  faBars as proFalFaBars,
  faSearch as proFalFaSearch,
  faPaperPlane as proFalFaPaperPlane,
  faMap as proFalFaMap,
  faLongArrowUp as proFalFaLongArrowUp,
  faHandPeace as proFalFaHandPeace,
  faQuestionCircle as proFalFaQuestionCircle,
  faThumbsUp as proFalFaThumbsUp,
  faFrown as proFalFaFrown,
  faBolt as proFalFaBolt,
  faPaintBrushAlt as proFalFaPaintBrushAlt,
  faSnooze as proFalFaSnooze,
  faStomach as proFalFaStomach,
  faShieldVirus as proFalFaShieldVirus,
  faDumbbell as proFalFaDumbbell,
  faHeart as proFalFaHeart,
  faBrain as proFalFaBrain,
  faChartNetwork as proFalFaChartNetwork,
  faPen as proFalFaPen,
  faTrashAlt as proFalFaTrashAlt
} from '@fortawesome/pro-light-svg-icons'

export default {freeFabFaTwitter, freeFabFaFacebookSquare, freeFabFaInstagram, freeFabFaYoutube, proFasFaEnvelope, proFasFaTimes, proFasFaAngleRight, proFasFaAngleLeft, proFasFaPlay, proFasFaTrashAlt, proFasFaExclamation, proFasFaCheck, proFasFaSort, proFasFaStar, proFasFaStarHalf, proFasFaStarHalfAlt, proFasFaImage, proFarFaEnvelope, proFarFaAngleRight, proFarFaAngleLeft, proFarFaPlusCircle, proFarFaMinusCircle, proFarFaChevronDown, proFarFaWifi, proFarFaList, proFarFaMap, proFarFaTimes, proFarFaStream, proFarFaTruck, proFarFaTshirt, proFarFaStar, proFarFaStarHalf, proFarFaStarHalfAlt, proFarFaTrashAlt, proFarFaMinus, proFarFaPlus, proFarFaCheck, proFarFaChevronRight, proFalFaEnvelope, proFalFaShoppingBag, proFalFaAngleRight, proFalFaAngleLeft, proFalFaPlusCircle, proFalFaMinusCircle, proFalFaArrowRight, proFalFaSpinner, proFalFaCheck, proFalFaTimes, proFalFaSpinnerThird, proFalFaChevronDown, proFalFaChevronLeft, proFalFaChevronUp, proFalFaChevronRight, proFalFaSlidersV, proFalFaUser, proFalFaBars, proFalFaSearch, proFalFaPaperPlane, proFalFaMap, proFalFaLongArrowUp, proFalFaHandPeace, proFalFaQuestionCircle, proFalFaThumbsUp, proFalFaFrown, proFalFaBolt, proFalFaPaintBrushAlt, proFalFaSnooze, proFalFaStomach, proFalFaShieldVirus, proFalFaDumbbell, proFalFaHeart, proFalFaBrain, proFalFaChartNetwork, proFalFaPen, proFalFaTrashAlt}